import React from 'react';
import PropTypes from 'prop-types';
import ForumOutlineIcon from 'mdi-react/ForumOutlineIcon';
import ChatOutlineIcon from 'mdi-react/ChatOutlineIcon';
import ShieldAccountOutlineIcon from 'mdi-react/ShieldAccountOutlineIcon';
import BullhornOutlineIcon from 'mdi-react/BullhornOutlineIcon';
import ShieldCheckOutlineIcon from 'mdi-react/ShieldCheckOutlineIcon';
import FilterRemoveOutlineIcon from 'mdi-react/FilterRemoveOutlineIcon';
import FlagOutlineIcon from 'mdi-react/FlagOutlineIcon';
import AccountRemoveOutlineIcon from 'mdi-react/AccountRemoveOutlineIcon';
import TimerSandIcon from 'mdi-react/TimerSandIcon';
import HistoryIcon from 'mdi-react/HistoryIcon';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import { partial } from '../../../util/translation/translation';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';
import ChatPreview from './ChatPreview';

/**
 * Chats in two steps: open a chat and post as the club, then fans talk
 * while the moderation tools keep it friendly.
 */
const ChatsShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  return (
    <FeatureShowcase
      storageKey="chatsShowcaseHidden"
      icon={ForumOutlineIcon}
      title={s('chatInfoTitle')}
      subtitle={s('chatShowcaseSubtitle')}
      showLabel={s('chatShowcaseShow')}
      uses={[
        {
          key: 'open',
          step: s('showcaseStep', { step: 1 }),
          icon: ChatOutlineIcon,
          label: s('chatOpenLabel'),
          text: s('chatOpenText'),
          cards: [
            {
              key: 'rooms',
              icon: ChatOutlineIcon,
              title: s('chatCardRooms'),
              text: s('chatCardRoomsText'),
            },
            {
              key: 'access',
              icon: ShieldAccountOutlineIcon,
              title: s('chatCardAccess'),
              text: s('chatCardAccessText'),
            },
            {
              key: 'club',
              icon: BullhornOutlineIcon,
              title: s('chatCardClub'),
              text: s('chatCardClubText'),
              points: [
                {
                  label: s('chatPointAnnouncements'),
                  text: s('chatPointAnnouncementsText'),
                },
                { label: s('chatPointPolls'), text: s('chatPointPollsText') },
                { label: s('chatPointPins'), text: s('chatPointPinsText') },
              ],
            },
          ],
        },
        {
          key: 'talk',
          step: s('showcaseStep', { step: 2 }),
          icon: ShieldCheckOutlineIcon,
          label: s('chatTalkLabel'),
          text: s('chatTalkText'),
          // A chat in the app; the poll can be voted in
          interactive: true,
          itemsBeside: true,
          preview: <ChatPreview />,
          items: [
            {
              key: 'words',
              icon: FilterRemoveOutlineIcon,
              label: s('chatItemWords'),
            },
            {
              key: 'reports',
              icon: FlagOutlineIcon,
              label: s('chatItemReports'),
            },
            {
              key: 'block',
              icon: AccountRemoveOutlineIcon,
              label: s('chatItemBlock'),
            },
            { key: 'slow', icon: TimerSandIcon, label: s('chatItemSlow') },
            { key: 'log', icon: HistoryIcon, label: s('chatItemLog') },
            { key: 'stats', icon: ChartBarIcon, label: s('chatItemStats') },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

ChatsShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

ChatsShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default ChatsShowcase;
